import { render, staticRenderFns } from "./Case.vue?vue&type=template&id=5cdb2212&"
import script from "./Case.vue?vue&type=script&lang=js&"
export * from "./Case.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Case.vue"
export default component.exports